(function(){
    angular
        .module('appback')
        .directive('ngBiologiamolecular', biologiamolecular);

        biologiamolecular.$inject = ['$timeout','GenerallabService','ResultadosService'];
        function biologiamolecular($timeout,GenerallabService,ResultadosService){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=biologiamolecular.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  //sub: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {


		            	scope.potencia = function(base,exponente){
							var r = 1;
							var i = 0; 
							while(i < exponente){
							    r = r * base;
							    i++;
							}
							return r;
		            	}
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : {  }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { }};
				            }else{
				            	if(!scope.item.resultado.extra.resultado){
				            		scope.item.resultado.extra.resultado = { };
					            }else{
					            	if(Array.isArray(scope.item.resultado.extra.resultado)){
				            			scope.item.resultado.extra.resultado = { };
					            	}
					            }
				            }
				        }

				        scope.getPotencia = function(){
				        	var resultado = ((scope.item.resultado.extra.resultado.ct - ((+scope.ct.interseccion) + (scope.item.resultado.extra.resultado.ct_stand-scope.ct.ct10e5)))/scope.ct.pendiente);
							
				        	//REVISAR IFS
							if(scope.item.resultado.extra.resultado.unidades=='cDNA/g'){
								//resultado = resultado * 200;
							}
							if(scope.item.resultado.extra.resultado.unidades=='cDNA/mL'){
								//resultado = resultado * 1600;
							}
							
				        	//console.log("num",resultado);
				        	//console.log("Potencia",Math.pow(10,resultado));
				        	scope.item.resultado.extra.resultado.concentracion =  Math.pow(10,resultado).toExponential(2);
				        	console.log("EXP", Math.pow(10,resultado).toExponential(2));
				        }

				        scope.getCtAnalitica = function(){
				        	ResultadosService.getCtAnalitica(scope,function(data){
				        		if(angular.isDefined(data.ct)){
				        			scope.ct = data.ct;
					        		scope.item.resultado.extra.resultado.lote = data.ct.id
				        		}
					        	
					        });
				        }
				        console.log("biologia");
				        scope.ct = {};

				        scope.getCtAnalitica();
				        

				     	scope.generalLab = GenerallabService;

			        });
		        }
          }
      }
})();